import { LoanApiService } from '../services/loan-api.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Cached } from '@lib/cache';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { requiredEnums } from '../constants';
import { sortBy } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class PosEnumResolverService implements Resolve<any> {
  private lookups: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private enumKeys = requiredEnums;

  constructor(private loanApiService: LoanApiService) {}

  @Cached('enumerations')
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.loanApiService.getEnumerations(this.enumKeys).pipe(
      map((enums: any) => {
        enums = this.parseEnums(enums);
        this.lookups.next(enums);
        return enums;
      })
    );
  }

  private parseEnums(enums) {
    const parsed: any = {};
    enums.forEach((key) => {
      parsed[key.name] = sortBy(key.options, 'order');
    });
    return parsed;
  }

  public getDisplayValue(option, key) {
    const lookups = this.lookups.value;
    const item = lookups && lookups[key] && lookups[key].find((state) => state.option === option);
    return (item && item.displayName) || option;
  }

  public getMetaValue(option, key, metaKey) {
    const lookups = this.lookups.value;
    const item = lookups && lookups[key] && lookups[key].find((state) => state.option === option);
    return item && item.meta && item.meta[metaKey];
  }
}
